module.exports = "/_next/static/images/04e51249201cd2d4bda8b5563d332a33-woman-using-cellphone@2x.png.webp";